import React from "react";
import ThePeak from "../components/projects/ThePeak";
import { getSEOData } from "../utils/seo";

export default () => {
  const seoData = getSEOData("the-peak-high-rise-apartments-in-ashok-nagar");
  return <ThePeak seoData={seoData} />;
};
